//
// Collection Sidedish

import _ from "underscore";
import ObjectCollection from "../prototypes/ObjectCollection";
import AppModel from "./AppModel";
import { ICartProductSidedish } from "./CartModel";
import ProductCollection from "@src/backbone/model/ProductCollection";
import CartProductCollection from "@src/backbone/model/CartProductCollection";
import { ICrossSellingChildProduct } from "@src/interface/Product";
import SidedishModel, {
  SidedishAttributes,
  isSublevelAllowingSidedish,
} from "./SidedishModel";
// import { ISideDish } from "@src/interface/Product";

var createSelectionItem = SidedishModel.createSelectionItem;

type Iterate = _.CollectionIterator<SidedishModel, void, SidedishModel[]>;

class SidedishCollection extends ObjectCollection<SidedishModel> {
  name = "SidedishCollection";
  idAttribute = "id_cross_selling";
  model = SidedishModel;
  static prepareSelection: (
    sidedishes: SidedishAttributes[],
    id_product_parent: string,
    app: AppModel,
    accompagnements?: CartProductCollection,
    presetSelection?: any
  ) => SidedishCollection;
  presetIndex: number | undefined;

  initialize(
    models?: Record<string, any>[] | SidedishModel[],
    options?: any
  ): void {
    // ObjectCollection constructor heritage
    super.initialize.apply(this, [models, options]);
  }
  filteredChild(id_parent: string) {
    return _(
      this.filter((c) => {
        const _id_parent = c.get("id_parent") || "";
        if (!_id_parent && id_parent === "0" && !!c.get("products"))
          return true;
        return _id_parent === id_parent;
      })
    );
  }
  sizeRoot() {
    return this.filteredChild("0").size();
  }
  eachChild(id_parent: string, iteratee: Iterate) {
    return this.filteredChild(id_parent).each(iteratee);
  }
  eachRoot(iteratee: Iterate) {
    return this.eachChild("0", iteratee);
  }
  getSimplifiedSelection(): ICartProductSidedish {
    const _selectionData: ICartProductSidedish = {};
    this.eachRoot((sidedish, index) => {
      let children = sidedish.getChildren();
      if (children.size() > 0) {
        children.each(function (sidedishChild) {
          _selectionData[sidedishChild.id] =
            sidedishChild.getSimplifiedSelection();
        });
      } else {
        _selectionData[sidedish.id] = sidedish.getSimplifiedSelection();
      }
    });

    return _selectionData;
  }
}

SidedishCollection.prototype.name = "SidedishCollection";
SidedishCollection.prototype.model = SidedishModel;

// cette fonction prépare une selection pour l'afficher sur la fiche produit.
SidedishCollection.prepareSelection = function (
  sidedishes: SidedishAttributes[],
  id_product_parent: string,
  app: AppModel,
  accompagnements?: CartProductCollection,
  presetSelection?: any[]
) {
  const cart = app.getCart();
  let presetIndex: number | undefined = undefined;
  const filtered = sidedishes.filter((s, si: number) => {
    const {
        products: _products,
        id_category,
        template = "default",
        midday,
        evening,
        visibility = [],
      } = s,
      isNowLunch = cart.isNowLunch();
    if (!_products) return false;
    const getProductsInContext = (
      id_category?: string,
      products: any[] = []
    ) => {
      let productsInContext: ProductCollection;
      productsInContext = app.getProducts().getProductsByIds(
        products.map((p) => p.id_product),
        true
      );
      return productsInContext;
    };
    const QuantityChildProductProps = (
      quantity_prop_name: keyof Omit<ICrossSellingChildProduct, "id_product">
    ) => {
      return (
        s.products?.reduce((acc, p) => {
          let quantity: number = p[quantity_prop_name] || 0;
          for (let i = 0; i < quantity; i++) {
            acc.push(p.id_product);
          }
          return acc;
        }, [] as string[]) || []
      );
    };
    const checkIsVisible = () => {
      const dateTime = cart.getDatetime();
      const v = visibility?.find((v: any) => v.day === dateTime.getDay());
      let visible;
      if (v) {
        const { time_deb = "00:00:00", time_end = "23:59:59" } = { ...v };
        function prepareTime(time: string): Date {
          const parts = time.split(":");
          const date = new Date(dateTime.toString());
          date.setHours(+parts[0]);
          date.setMinutes(+parts[1]);
          date.setSeconds(+parts[2] || 0);
          return date;
        }
        const dateDeb = prepareTime(time_deb);
        const dateEnd = prepareTime(time_end);
        visible =
          dateTime.getTime() >= dateDeb.getTime() &&
          dateTime.getTime() <= dateEnd.getTime();
      } else {
        visible = false;
      }
      return visible;
    };
    let isVisible = checkIsVisible(),
      isNotEmpty = getProductsInContext(id_category, _products).size() > 0,
      isGroupedList = ["grouped_list", "custom_box_42"].includes(template),
      id_product_default =
        s.id_product_default || QuantityChildProductProps("quantity_default"),
      id_product_immutable =
        s.id_product_immutable ||
        QuantityChildProductProps("quantity_immutable"),
      initialSelection: any[] = [],
      isChildrenVisibles = false,
      filtered,
      pos_custom_box: number[] = [...(s.pos_custom_box || [])]; // position of selection in custom box

    // check if there is at least one attached sidedish
    filtered = isVisible && (isNotEmpty || isChildrenVisibles);

    if (filtered) {
      function shiftPosition() {
        return pos_custom_box.shift() || "*";
      }

      if (accompagnements && accompagnements.models) {
        // édition d'une selection existante
        accompagnements.forEach((accompagnement) => {
          const id_cross_selling = accompagnement.get("id_cross_selling");
          // filtre uniquement les accompagnements de la selection
          if (+id_cross_selling !== +s.id_cross_selling) return;
          const id_product = accompagnement.get("id_product"),
            qty = accompagnement.getQuantity(),
            qtyImmutable =
              id_product_immutable.reduce((count, id) => {
                return id === id_product ? count + 1 : count;
              }, 0) || 0;

          // portée par les CrossSelling du produit enfant/choisi, pas par le parent `s`
          const childSidedishes = id_product
            ? (app.getProduct(id_product)?.get("sidedishes") as unknown as
                | SidedishAttributes[]
                | undefined)
            : undefined;
          const allowSublevel = !!childSidedishes?.some(
            isSublevelAllowingSidedish
          );

          // l'API sort une entrée par unité (`quantity: 1`) sur un produit
          // éligible au sous-niveau — à fusionner en un seul item.
          let item = allowSublevel
            ? _(initialSelection).findWhere({ id: id_product })
            : undefined;
          if (!item) {
            item = createSelectionItem(
              id_product,
              id_product_parent,
              qty,
              0,
              qtyImmutable,
              shiftPosition
            );
            initialSelection.push(item);
          } else {
            const subSelections =
              item.subSelections || (item.subSelections = []);
            for (let i = 0; i < qty; i++) {
              item.positions.push(shiftPosition());
              subSelections.push(null);
            }
            item.quantity += qty;
            item.immutable += qtyImmutable;
          }

          // réhydrate les sous-choix du panier, sinon l'édition les voit vides
          if (allowSublevel && item.quantity > 0 && id_product) {
            const sublevel = accompagnement.getSublevel();
            if (sublevel.size() && childSidedishes) {
              const subSelections: (SidedishCollection | null)[] =
                item.subSelections || (item.subSelections = []);
              const unitIndex = subSelections.findIndex((sub) => !sub);
              if (unitIndex >= 0) {
                subSelections[unitIndex] = SidedishCollection.prepareSelection(
                  childSidedishes,
                  id_product,
                  app,
                  sublevel
                );
              }
            }
          }
        });
      } else {
        // nouvelle selection
        _(_.countBy(id_product_immutable || "")).each(function (
          qty,
          id_product
        ) {
          // ajoute les produits immuables à la selection
          initialSelection.push(
            createSelectionItem(
              id_product,
              id_product_parent,
              qty,
              0,
              qty,
              shiftPosition
            )
          );
        });
        function setDefault(qty: number, id_product: any) {
          // ajoute les produits par défaut à la selection
          let defaultSelection = _(initialSelection).findWhere({
            id: id_product,
          });
          if (!defaultSelection) {
            defaultSelection = createSelectionItem(
              id_product,
              id_product_parent,
              qty,
              qty,
              0,
              shiftPosition
            );
            initialSelection.push(defaultSelection);
          } else {
            for (let i = 0; i < qty; i++)
              defaultSelection.positions.push(shiftPosition());
            defaultSelection.quantity += qty;
            defaultSelection.default = qty;
          }
        }
        let preset;
        if (presetSelection && (preset = presetSelection[si])) {
          // préselection (product boost)
          if (preset.length > 0) {
            // s'il y a une quantité sélectionnée
            presetIndex = si; // en cas de boost produit
          } else if (!presetIndex) {
            presetIndex = 0; // on est à minima sur la première étape.
          }
          _(_.countBy(preset, "id")).each(setDefault);
        } else {
          // selection par défaut
          _(_.countBy(id_product_default)).each(setDefault);
        }
      }
      // attribute;
      s.selection = initialSelection;
    }
    return filtered;
  });

  const collection = new SidedishCollection(filtered);
  collection.presetIndex = presetIndex;
  return collection;
};

export default SidedishCollection;
